
import SessionData from "../../services/session/SessionData"
import { SessionService } from "../../services/session/SessionService"
import ClientBase from './ClientBase'

class SecureClient extends ClientBase {

	protected readonly _sessionService = SessionService.getInstance()
	private readonly AuthorizationHeaderName: string = "authorization"
	private readonly OrganizationAccessHeaderName: string = "organization-token"

	constructor() {
		super()
	}

	protected get hasAuthorizationHeader(): boolean {
		return !!SessionData.accessToken.raw
	}

	protected get authorizationHeader(): AuthorizeHeader {
		if (!SessionData.accessToken.raw)
			throw new Error(
				"cannot make secured call without authentication token")
		return { Authorization: `Bearer ${SessionData.accessToken.raw}` }
	}
}

export type AuthorizeHeader = {
	'Authorization': string
}

export type OrganizationHeader = {
	'organization-token': string
}

export default SecureClient
